import { AutomatedMessageType } from "~/components/Admin/Settings/automatedMessages/validation"
import { IAutomatedMessages } from "../interfaces/AutomatedMessages"
import { get, post, destroy } from "./utils/requests"

const fetch = async (id: string): Promise<{ automated_message_templates: IAutomatedMessages[] }> =>
  get(`/api/camps/${id}/automated_message_templates`)

const update = async ({
  id,
  value,
}: {
  id: string
  value: AutomatedMessageType[]
}): Promise<{ automated_message_templates: IAutomatedMessages[] }> =>
  post(`/api/camps/${id}/automated_message_templates`, { automated_message_templates_attributes: value })

const deleteMessage = async (camp_id: string, message_id: string) =>
  destroy(`/api/camps/${camp_id}/automated_message_templates/${message_id}`, { id: message_id, _destroy: true })

const sendTestAutomatedMessage = async (
  campId: string,
  params: {
    subject: string
    content: string
    sendTiming: number | null
    isCopyingCampEmail: boolean
    isBeforeCheckin: boolean
  }
) => {
  return post(`/api/camps/${campId}/automated_message_templates/test_email`, params)
}

const AutomatedMessage = {
  fetch,
  update,
  deleteMessage,
  sendTestAutomatedMessage
}

export default AutomatedMessage
